import PropTypes from 'prop-types';
import React from 'react';

import HelpPanelActions from '../HelpPanelActions';

import styles from './BetslipHelpPanel.module.scss';

export const BetslipHelpPanel = ({ liveChatEnabled = false, onStartTour }) => (
  <aside className={styles.main} data-hook="betslip-help-panel">
    <HelpPanelActions
      liveChatEnabled={liveChatEnabled}
      onStartTour={onStartTour}
      dataHookPrefix="betslip-help"
      layout="inline"
    />
  </aside>
);

BetslipHelpPanel.propTypes = {
  liveChatEnabled: PropTypes.bool,
  onStartTour: PropTypes.func.isRequired,
};

export default BetslipHelpPanel;
